export default __webpack_public_path__ + "static/media/turkey-1.13f810c6.png";